/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioTypeV2 } from './InternalApiScenarioTypeV2';
import {
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2FromJSONTyped,
    InternalApiScenarioTypeV2ToJSON,
    InternalApiScenarioTypeV2ToJSONTyped,
} from './InternalApiScenarioTypeV2';

/**
 * Metrics shown on scenario list view
 * @export
 * @interface InternalApiScenarioMetric
 */
export interface InternalApiScenarioMetric {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioMetric
     */
    scenarioHandle: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioMetric
     */
    scenarioName: string;
    /**
     * 
     * @type {InternalApiScenarioTypeV2}
     * @memberof InternalApiScenarioMetric
     */
    scenarioType: InternalApiScenarioTypeV2;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioMetric
     */
    alertCount: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioMetric
     */
    alertCountPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioMetric
     */
    truePositivePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioMetric
     */
    meaningfulAlertPercentage: number;
}



/**
 * Check if a given object implements the InternalApiScenarioMetric interface.
 */
export function instanceOfInternalApiScenarioMetric(value: object): value is InternalApiScenarioMetric {
    if (!('scenarioHandle' in value) || value['scenarioHandle'] === undefined) return false;
    if (!('scenarioName' in value) || value['scenarioName'] === undefined) return false;
    if (!('scenarioType' in value) || value['scenarioType'] === undefined) return false;
    if (!('alertCount' in value) || value['alertCount'] === undefined) return false;
    if (!('alertCountPercentage' in value) || value['alertCountPercentage'] === undefined) return false;
    if (!('truePositivePercentage' in value) || value['truePositivePercentage'] === undefined) return false;
    if (!('meaningfulAlertPercentage' in value) || value['meaningfulAlertPercentage'] === undefined) return false;
    return true;
}

export function InternalApiScenarioMetricFromJSON(json: any): InternalApiScenarioMetric {
    return InternalApiScenarioMetricFromJSONTyped(json, false);
}

export function InternalApiScenarioMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioMetric {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandle': json['scenarioHandle'],
        'scenarioName': json['scenarioName'],
        'scenarioType': InternalApiScenarioTypeV2FromJSON(json['scenarioType']),
        'alertCount': json['alertCount'],
        'alertCountPercentage': json['alertCountPercentage'],
        'truePositivePercentage': json['truePositivePercentage'],
        'meaningfulAlertPercentage': json['meaningfulAlertPercentage'],
    };
}

export function InternalApiScenarioMetricToJSON(json: any): InternalApiScenarioMetric {
    return InternalApiScenarioMetricToJSONTyped(json, false);
}

export function InternalApiScenarioMetricToJSONTyped(value?: InternalApiScenarioMetric | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandle': value['scenarioHandle'],
        'scenarioName': value['scenarioName'],
        'scenarioType': InternalApiScenarioTypeV2ToJSON(value['scenarioType']),
        'alertCount': value['alertCount'],
        'alertCountPercentage': value['alertCountPercentage'],
        'truePositivePercentage': value['truePositivePercentage'],
        'meaningfulAlertPercentage': value['meaningfulAlertPercentage'],
    };
}

